module.exports = __webpack_public_path__ + "static/media/charity_save_the_children.936663fa.png";